import { format, parseISO } from 'date-fns';
import { getEntityRoleLabel } from './terminology';

export const formatTime = (dateStr) => {
  try { return format(parseISO(dateStr), 'hh:mm:ss a'); }
  catch { return dateStr; }
};

export const formatDate = (dateStr) => {
  try { return format(parseISO(dateStr), 'dd MMM yyyy'); }
  catch { return dateStr; }
};

export const formatDateTime = (dateStr) => {
  try { return format(parseISO(dateStr), 'dd MMM yyyy, hh:mm a'); }
  catch { return dateStr; }
};

export const getRoleBadgeColor = (role) => {
  const colors = {
    admin:    'bg-purple-100 text-purple-800',
    teacher:  'bg-blue-100 text-blue-800',
    manager:  'bg-indigo-100 text-indigo-800',
    student:  'bg-green-100 text-green-800',
    employee: 'bg-orange-100 text-orange-800',
  };
  return colors[role] || 'bg-gray-100 text-gray-800';
};

export const getRoleDisplayName = (role, category, fallbackName) => (
  getEntityRoleLabel(role, category, fallbackName)
);

export const getDirectionColor = (direction) => {
  return direction === 'in'
    ? 'bg-green-100 text-green-800'
    : 'bg-red-100 text-red-800';
};
